import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type DeviceType = 'pc' | 'iphone';

interface DeviceState {
  deviceType: DeviceType;
  setDeviceType: (type: DeviceType) => void;
}

export const useDeviceStore = create<DeviceState>()(
  persist(
    (set) => ({
      deviceType: 'iphone',
      setDeviceType: (deviceType) => set({ deviceType }),
    }),
    {
      name: 'sprint-analysis-device',
    }
  )
);